__webpack_require__.p = "/co2dashboard/";